document.addEventListener('DOMContentLoaded',()=>{const b=document.querySelector('[data-menu-toggle]'),n=document.querySelector('[data-nav]');if(b&&n)b.addEventListener('click',()=>{n.classList.toggle('is-open');b.setAttribute('aria-expanded',n.classList.contains('is-open'))});document.querySelectorAll('[data-copy-coupon]').forEach(b=>b.addEventListener('click',async()=>{await navigator.clipboard.writeText(b.dataset.copyCoupon);const old=b.textContent;b.textContent='Cupom copiado!';setTimeout(()=>b.textContent=old,1800)}))});

/* ===== Carrinho AJAX + animação + recomendações ===== */
(function(){
  function refreshCount(bump){
    fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){
      var els=document.querySelectorAll('.cart-count');
      els.forEach(function(el){
        el.textContent=c.item_count;
        el.style.visibility=c.item_count>0?'visible':'hidden';
        if(bump){el.classList.remove('is-bump');void el.offsetWidth;el.classList.add('is-bump');}
      });
      /* is-filled controla o anel dourado da sacola e a visibilidade do contador. */
      document.querySelectorAll('.cart-link').forEach(function(link){ link.classList.toggle('is-filled',c.item_count>0); });
    }).catch(function(){});
  }
  function flyToCart(img){
    var mobileCart=document.querySelector('.mobile-app-nav__fab');
    var cart=mobileCart&&mobileCart.offsetParent!==null?mobileCart:document.querySelector('.site-header .cart-link');
    if(!img||!cart)return;
    var s=img.getBoundingClientRect(),d=cart.getBoundingClientRect();
    var f=img.cloneNode(true);f.removeAttribute('class');f.removeAttribute('loading');
    var st=f.style;
    st.position='fixed';st.left=s.left+'px';st.top=s.top+'px';st.width=s.width+'px';st.height=s.height+'px';
    st.margin='0';st.borderRadius='6px';st.objectFit='contain';st.zIndex='9999';st.pointerEvents='none';
    st.boxShadow='0 12px 30px rgba(0,0,0,.28)';st.transition='transform .8s cubic-bezier(.2,.7,.25,1),opacity .8s ease';
    document.body.appendChild(f);
    var dx=(d.left+d.width/2)-(s.left+s.width/2),dy=(d.top+d.height/2)-(s.top+s.height/2);
    void f.offsetWidth;
    st.transform='translate('+dx+'px,'+dy+'px) scale(.12)';st.opacity='.15';
    setTimeout(function(){
      f.remove();
      cart.classList.remove('is-receiving');
      void cart.offsetWidth;
      cart.classList.add('is-receiving');
      setTimeout(function(){cart.classList.remove('is-receiving');},500);
    },820);
  }
  function feedback(btn){
    if(!btn)return;
    var orig=btn.getAttribute('data-orig')||btn.textContent;
    btn.setAttribute('data-orig',orig);
    btn.textContent='Adicionado ✓';btn.classList.add('is-added');
    clearTimeout(btn._t);
    btn._t=setTimeout(function(){btn.textContent=orig;btn.classList.remove('is-added');},1500);
  }
  function feedbackErro(btn,msg){
    if(!btn)return;
    var orig=btn.getAttribute('data-orig')||btn.textContent;
    btn.setAttribute('data-orig',orig);
    btn.textContent=msg;btn.classList.add('is-erro');
    clearTimeout(btn._t);
    btn._t=setTimeout(function(){btn.textContent=orig;btn.classList.remove('is-erro');},2600);
  }
  document.addEventListener('submit',function(e){
    var form=e.target;
    if(!form.matches||!form.matches('form[action*="/cart/add"]'))return;
    if(form.querySelector('input[name="return_to"]'))return;
    e.preventDefault();
    var btn=form.querySelector('[type="submit"]');
    var img=null,card=form.closest('.product-card'),row=form.closest('.search-row'),reco=form.closest('.cart-reco__card');
    if(card)img=card.querySelector('.product-card__image img');
    if(row)img=row.querySelector('img');
    if(reco)img=reco.querySelector('img');
    if(!img&&!row&&!reco)img=document.querySelector('.product-gallery__frame img');
    fetch('/cart/add.js',{method:'POST',body:new FormData(form),headers:{'Accept':'application/json'}})
      .then(function(r){
        if(!r.ok){
          /* 422 é regra da loja (estoque), não falha de rede. Recarregar o form
             jogaria o cliente numa tela de erro da Shopify e ele perderia o lugar. */
          return r.json().then(
            function(b){ throw {daLoja:true, msg:b.description||b.message}; },
            function(){ throw {daLoja:false}; }
          );
        }
        return r.json();
      })
      .then(function(){
        flyToCart(img);refreshCount(true);feedback(btn);
        /* A gaveta aberta não escuta este fetch — sem isso, a barra de frete
           grátis e a lista de itens dela ficariam desatualizadas até fechar
           e reabrir. Só dispara pro form da recomendação da própria gaveta. */
        if(form.closest('[data-cart-reco]')) document.dispatchEvent(new CustomEvent('cart:changed'));
      })
      .catch(function(e){
        if(e&&e.daLoja){ feedbackErro(btn,'Estoque insuficiente'); refreshCount(false); return; }
        form.submit();
      });
  });
  function loadReco(){
    document.querySelectorAll('[data-reco-url]').forEach(function(box){
      fetch(box.getAttribute('data-reco-url')).then(function(r){return r.text();}).then(function(html){
        var tmp=document.createElement('div');tmp.innerHTML=html;
        var sec=tmp.querySelector('.reco');
        if(sec)box.innerHTML=sec.outerHTML;
      }).catch(function(){});
    });
  }
  document.addEventListener('DOMContentLoaded',function(){refreshCount(false);loadReco();});
})();

/* ===== Gaveta lateral do carrinho ===== */
(function(){
  function drawerEl(){ return document.querySelector('[data-cart-drawer]'); }
  function setCount(n){
    document.querySelectorAll('.cart-count').forEach(function(el){ el.textContent=n; el.style.visibility=n>0?'visible':'hidden'; });
    document.querySelectorAll('.cart-link').forEach(function(link){ link.classList.toggle('is-filled',n>0); });
  }
  function replaceDrawer(html){
    var tmp=document.createElement('div'); tmp.innerHTML=html;
    var fresh=tmp.querySelector('[data-cart-drawer]'), cur=drawerEl();
    if(fresh&&cur){ fresh.classList.add('is-open'); fresh.setAttribute('aria-hidden','false'); cur.replaceWith(fresh); }
  }
  function refreshDrawer(){
    fetch('/?section_id=cart-drawer').then(function(r){return r.text();}).then(function(html){ replaceDrawer(html); }).catch(function(){});
  }
  function openDrawer(){
    var d=drawerEl();
    if(d){ d.classList.add('is-open'); d.setAttribute('aria-hidden','false'); document.body.classList.add('drawer-open'); }
    refreshDrawer();
  }
  function closeDrawer(){
    var d=drawerEl(); if(d){ d.classList.remove('is-open'); d.setAttribute('aria-hidden','true'); }
    document.body.classList.remove('drawer-open');
  }
  /* Re-lê o carrinho de verdade. Usado quando a resposta de uma mutação não
     traz o estado (erro), para o contador não ficar dessincronizado da sacola. */
  function syncFromCart(){
    fetch('/cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(c){ setCount(c.item_count); })
      .catch(function(){});
  }
  /* Aviso dentro da gaveta. Some sozinho; a próxima re-renderização também o remove. */
  function notify(msg){
    var d=drawerEl(); if(!d||!msg) return;
    var alvo=d.querySelector('.drawer__body')||d.querySelector('.drawer__panel'); if(!alvo) return;
    var antigo=d.querySelector('[data-cart-note]'); if(antigo) antigo.remove();
    var n=document.createElement('p');
    n.className='cart-note'; n.setAttribute('data-cart-note',''); n.setAttribute('role','status');
    n.textContent=msg;
    alvo.insertBefore(n,alvo.firstChild);
    clearTimeout(notify._t);
    notify._t=setTimeout(function(){ if(n.parentNode) n.remove(); },7000);
  }
  function change(key,qty){
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty,sections:'cart-drawer'})})
      .then(function(r){ return r.json().then(function(body){ return {ok:r.ok, body:body}; }); })
      .then(function(res){
        if(!res.ok){
          /* Estoque insuficiente e afins voltam 422 SEM item_count. Assumir que
             sempre vem o carrinho zerava o contador e tirava o anel da sacola:
             ela parecia vazia com itens dentro. A quantidade na gaveta já está
             correta (não mudou), então basta ressincronizar e avisar. */
          notify(res.body.description||res.body.message||'Não foi possível atualizar a quantidade.');
          syncFromCart();
          return;
        }
        setCount(res.body.item_count);
        if(res.body.sections&&res.body.sections['cart-drawer']) replaceDrawer(res.body.sections['cart-drawer']);
      })
      .catch(function(){ syncFromCart(); });
  }
  document.addEventListener('click',function(e){
    var cartLink=e.target.closest('.cart-link');
    if(cartLink){ e.preventDefault(); openDrawer(); return; }
    if(e.target.closest('[data-drawer-close]')){ e.preventDefault(); closeDrawer(); return; }
    var line=e.target.closest('.drawer-line');
    if(line){
      var key=line.getAttribute('data-key');
      var numEl=line.querySelector('.qty__num');
      var q=parseInt(numEl?numEl.textContent:'1',10)||1;
      if(e.target.closest('[data-qty-up]')){ change(key,q+1); }
      else if(e.target.closest('[data-qty-down]')){ change(key,Math.max(0,q-1)); }
      else if(e.target.closest('[data-remove]')){ change(key,0); }
    }
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeDrawer(); });
  /* A recomendação da gaveta ("frequentemente comprados juntos") some pela
     Section Rendering API a cada mudança, mas um /cart/add.js genérico não
     re-renderiza a gaveta sozinho — este evento é o gatilho pra isso. */
  document.addEventListener('cart:changed', refreshDrawer);
})();

/* ===== Cabeçalho condensa ao rolar (logo some, busca+sacola ficam) ===== */
(function(){
  var h=document.querySelector('.site-header');
  if(!h)return;
  function onScroll(){ if(window.scrollY>50){ h.classList.add('is-scrolled'); } else { h.classList.remove('is-scrolled'); } }
  window.addEventListener('scroll',onScroll,{passive:true});
  onScroll();
})();

/* ===== Descrição do produto: "Ler mais" só se estourar ===== */
(function(){
  var desc=document.querySelector('.product-desc');
  if(!desc)return;
  var rte=desc.querySelector('.rte'), btn=desc.querySelector('[data-desc-toggle]');
  if(!rte||!btn)return;
  if(rte.scrollHeight>rte.clientHeight+4){ btn.hidden=false; }
  btn.addEventListener('click',function(){
    var open=desc.classList.toggle('is-expanded');
    btn.textContent=open?'Ler menos':'Ler mais';
  });
})();

/* ===== Busca em bottom sheet + sugestões do acervo ===== */
(function(){
  var sheet=document.querySelector('[data-search-sheet]');
  if(!sheet)return;
  var shell=document.querySelector('.page-shell');
  var input=sheet.querySelector('[data-search-input]');
  var results=sheet.querySelector('[data-search-results]');
  var hint=sheet.querySelector('[data-search-hint]');
  var clearBtn=sheet.querySelector('[data-search-clear]');
  var suggestUrl=sheet.getAttribute('data-suggest-url')||'/search/suggest';
  var vv=window.visualViewport;
  var timer=null,seq=0,lastTerm=null;

  /* Sobe o painel acima do teclado virtual (iOS/Android mantêm o fixed atrás dele). */
  function fitKeyboard(){
    var inset=Math.max(0,window.innerHeight-vv.height-vv.offsetTop);
    sheet.style.setProperty('--kb',inset+'px');
  }
  function open(){
    if(sheet.classList.contains('is-open'))return;
    /* Ancora o zoom out no centro do que está visível, não no topo da página. */
    if(shell)shell.style.setProperty('--shell-origin',(window.scrollY+window.innerHeight/2)+'px');
    sheet.hidden=false;
    void sheet.offsetWidth;
    sheet.classList.add('is-open');
    sheet.setAttribute('aria-hidden','false');
    document.body.classList.add('search-open');
    if(vv){vv.addEventListener('resize',fitKeyboard);vv.addEventListener('scroll',fitKeyboard);}
    setTimeout(function(){if(input)input.focus();},240);
  }
  function close(){
    if(!sheet.classList.contains('is-open'))return;
    sheet.classList.remove('is-open');
    sheet.setAttribute('aria-hidden','true');
    document.body.classList.remove('search-open');
    if(vv){vv.removeEventListener('resize',fitKeyboard);vv.removeEventListener('scroll',fitKeyboard);}
    sheet.style.removeProperty('--kb');
    if(input)input.blur();
    setTimeout(function(){if(!sheet.classList.contains('is-open'))sheet.hidden=true;},440);
  }
  function paint(html){
    var tmp=document.createElement('div');
    tmp.innerHTML=html;
    var box=tmp.querySelector('[data-predictive-root]');
    results.innerHTML=box?box.innerHTML.trim():'';
    if(hint)hint.hidden=results.innerHTML!=='';
  }
  function reset(){
    seq++;
    results.innerHTML='';
    if(hint)hint.hidden=false;
  }
  function suggest(term){
    var mine=++seq;
    var url=suggestUrl+'?q='+encodeURIComponent(term)
      +'&section_id=predictive-search'
      +'&resources[type]=product,collection'
      +'&resources[limit]=10'
      +'&resources[options][unavailable_products]=last'
      +'&resources[options][fields]=title,vendor,tag,variants.barcode,body';
    fetch(url,{headers:{'Accept':'text/html'}})
      .then(function(r){return r.text();})
      .then(function(html){if(mine===seq)paint(html);})
      .catch(function(){});
  }
  function onInput(){
    var term=input.value.trim();
    if(clearBtn)clearBtn.hidden=term==='';
    clearTimeout(timer);
    if(term.length<2){reset();lastTerm=null;return;}
    if(term===lastTerm)return;
    timer=setTimeout(function(){lastTerm=term;suggest(term);},220);
  }

  document.addEventListener('click',function(e){
    if(!e.target.closest)return;
    if(e.target.closest('[data-search-open]')){e.preventDefault();open();return;}
    if(e.target.closest('[data-search-close]')){e.preventDefault();close();return;}
    if(e.target.closest('[data-search-clear]')){e.preventDefault();input.value='';onInput();input.focus();}
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&sheet.classList.contains('is-open'))close();});
  if(input){input.addEventListener('input',onInput);input.addEventListener('search',onInput);}
})();

/* ===== Welcome sheet (convite instalar / boas-vindas) ===== */
(function(){
  var sheet=document.getElementById('welcome-sheet');
  if(!sheet) return;
  var standalone=(window.matchMedia&&window.matchMedia('(display-mode: standalone)').matches)||navigator.standalone===true;
  var isMobile=window.matchMedia&&window.matchMedia('(max-width:720px)').matches;
  var isIOS=/iphone|ipad|ipod/i.test(navigator.userAgent);
  var seen=false; try{ seen=localStorage.getItem('adl_welcome_seen')==='1'; }catch(e){}
  var deferred=null;
  window.addEventListener('beforeinstallprompt',function(e){ e.preventDefault(); deferred=e; });
  function seenNow(){ try{ localStorage.setItem('adl_welcome_seen','1'); }catch(e){} }
  function open(){ sheet.hidden=false; void sheet.offsetWidth; sheet.classList.add('is-open'); seenNow(); }
  function close(){ sheet.classList.remove('is-open'); seenNow(); setTimeout(function(){ sheet.hidden=true; },420); }
  if(!seen && !standalone && isMobile){
    if(isIOS){ var ios=sheet.querySelector('[data-welcome-ios]'); if(ios) ios.hidden=false; }
    setTimeout(open,1600);
  }
  sheet.addEventListener('click',function(e){
    if(e.target.closest('[data-welcome-close]')){ close(); return; }
    if(e.target.closest('[data-welcome-install]')){
      if(deferred){ deferred.prompt(); if(deferred.userChoice){ deferred.userChoice.then(function(){}).catch(function(){}).then(function(){ deferred=null; close(); }); } else { close(); } }
      else if(isIOS){ var ios=sheet.querySelector('[data-welcome-ios]'); if(ios){ ios.hidden=false; } }
      else { close(); }
    }
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape' && sheet.classList.contains('is-open')) close(); });
})();

/* ===== Busca preditiva no desktop =====
   O sheet com sugestões só existia no mobile; aqui o campo do cabeçalho era um form
   puro. Reusa a mesma seção predictive-search, ancorada abaixo do campo. */
(function(){
  var form=document.querySelector('[data-desktop-search]');
  if(!form)return;
  var input=form.querySelector('[data-desktop-search-input]');
  var box=form.querySelector('[data-desktop-search-results]');
  if(!input||!box)return;
  var timer=null,seq=0,ultimo=null;
  function fechar(){ box.hidden=true; box.innerHTML=''; input.setAttribute('aria-expanded','false'); }
  function sugerir(termo){
    var meu=++seq;
    var url='/search/suggest?q='+encodeURIComponent(termo)
      +'&section_id=predictive-search'
      +'&resources[type]=product,collection'
      +'&resources[limit]=10'
      +'&resources[options][unavailable_products]=last'
      +'&resources[options][fields]=title,vendor,tag,variants.barcode,body';
    fetch(url,{headers:{'Accept':'text/html'}})
      .then(function(r){return r.text();})
      .then(function(html){
        if(meu!==seq)return;                     /* resposta atrasada de termo antigo */
        var tmp=document.createElement('div');tmp.innerHTML=html;
        var raiz=tmp.querySelector('[data-predictive-root]');
        var conteudo=raiz?raiz.innerHTML.trim():'';
        box.innerHTML=conteudo;
        box.hidden=conteudo==='';
        input.setAttribute('aria-expanded',conteudo===''?'false':'true');
      }).catch(function(){});
  }
  input.addEventListener('input',function(){
    var t=input.value.trim();
    clearTimeout(timer);
    if(t.length<2){fechar();ultimo=null;return;}
    if(t===ultimo)return;
    timer=setTimeout(function(){ultimo=t;sugerir(t);},220);
  });
  input.addEventListener('keydown',function(e){ if(e.key==='Escape')fechar(); });
  document.addEventListener('click',function(e){ if(!form.contains(e.target))fechar(); });
})();

/* ===== Página do carrinho: quantidade se aplica sozinha =====
   A gaveta já recalculava a cada clique, mas a página /cart dependia do botão
   "Atualizar". Quem digitava outra quantidade e ia direto ao checkout via aqui a
   linha e o subtotal antigos — a barra chegava a dizer "frete grátis" enquanto o
   checkout cobrava. Sem JS o <noscript> devolve o botão. */
(function(){
  var qty=document.querySelector('[data-cart-qty]');
  if(!qty)return;
  var form=qty.form;
  if(!form)return;
  form.addEventListener('change',function(e){
    if(!e.target.matches||!e.target.matches('[data-cart-qty]'))return;
    /* Nada de desabilitar o campo aqui: campo disabled não entra no envio, e o
       updates[] dele sumiria — a quantidade nova nunca chegaria ao servidor.
       Uma trava no próprio form já evita envio duplo enquanto a página recarrega. */
    if(form.dataset.enviando)return;
    form.dataset.enviando='1';
    form.submit();
  });
})();

/* ===== Barra de compra fixa no mobile =====
   Aparece só depois que o botão original sobe para fora da tela, para não competir
   com ele. Listener de rolagem em vez de IntersectionObserver, igual ao cabeçalho
   que condensa: é o padrão já usado aqui e não depende do ciclo de composição. */
(function(){
  var bar=document.querySelector('[data-buy-bar]');
  var cta=document.querySelector('.product-form__cta');
  if(!bar||!cta)return;
  function avaliar(){
    bar.hidden = cta.getBoundingClientRect().bottom > 0;
  }
  window.addEventListener('scroll',avaliar,{passive:true});
  window.addEventListener('resize',avaliar,{passive:true});
  avaliar();
})();

/* Ordenação da coleção: envia o form ao trocar a opção.
   Sem JS o <noscript> mostra o botão "Ordenar", então a função não se perde. */
(function(){
  var form = document.querySelector('form[data-auto-submit]');
  if(!form) return;
  var select = form.querySelector('select[name="sort_by"]');
  if(!select) return;
  select.addEventListener('change', function(){
    form.submit();
    select.disabled = true;          // evita novo envio durante o carregamento da pagina
  });
})();

/* ===== Descrição da coleção: "Ler mais" só se estourar (mobile) =====
   Lógica igual à do .product-desc da PDP, mas isolada — não reaproveita o
   IIFE de lá porque a coleção pode ter zero ou várias descrições na página. */
(function(){
  var boxes = document.querySelectorAll('[data-collection-desc]');
  boxes.forEach(function(box){
    var rte = box.querySelector('.rte');
    var btn = box.querySelector('[data-collection-desc-toggle]');
    if(!rte || !btn) return;
    if(rte.scrollHeight > rte.clientHeight + 2){
      btn.hidden = false;
      btn.addEventListener('click', function(){
        box.classList.add('is-expanded');
        btn.hidden = true;
      });
    }
  });
})();

/* ===== Leque de destaques do hero =====
   As capas sao <a> de verdade para o produto: sem JS, tocar leva direto ao
   livro e o rastreador segue o link normalmente.

   Com JS a regra e de dois tempos: capa nao selecionada, o toque seleciona
   (o painel abaixo passa a descreve-la); capa ja selecionada, o toque navega.
   Nenhum toque morre — o primeiro sempre produz algo visivel na tela.

   No desktop o mouseenter ja seleciona, entao o clique cai direto no segundo
   tempo e navega, como o usuario espera de um link. So ha handler de hover
   onde existe ponteiro fino: em touch, 'mouseenter' e emulado depois do toque
   e roubaria o primeiro tempo. */
(function(){
  var shelf = document.querySelector('[data-hero-shelf]');
  if(!shelf) return;

  var items = [].slice.call(shelf.querySelectorAll('[data-shelf-item]'));
  var elTitle = shelf.querySelector('[data-shelf-title]');
  var elAuthor = shelf.querySelector('[data-shelf-author]');
  var elCta = shelf.querySelector('[data-shelf-cta]');
  if(items.length < 2 || !elTitle || !elCta) return;

  var ponteiroFino = window.matchMedia &&
    window.matchMedia('(hover:hover) and (pointer:fine)').matches;

  function selecionar(item){
    if(item.classList.contains('is-active')) return;
    items.forEach(function(outro){ outro.classList.remove('is-active'); });
    item.classList.add('is-active');
    elTitle.textContent = item.getAttribute('data-title') || '';
    if(elAuthor){
      var autor = item.getAttribute('data-author') || '';
      elAuthor.textContent = autor;
      elAuthor.hidden = (autor === '');
    }
    elCta.setAttribute('href', item.getAttribute('href'));
  }

  items.forEach(function(item){
    item.addEventListener('click', function(e){
      if(item.classList.contains('is-active')) return;   // segundo tempo: navega
      e.preventDefault();
      selecionar(item);
    });
    if(ponteiroFino){
      item.addEventListener('mouseenter', function(){ selecionar(item); });
    }
  });
})();
